import { useSuspenseQuery } from '@tanstack/react-query';
import type { IGetItemsLayoutParams } from 'api/resources/layout';
import { getItemsLayout } from 'api/resources/layout';
import { ECacheKeys } from 'cache/CacheKeys';

export const useGetItemsLayout = (params: IGetItemsLayoutParams) => {
	const query = useSuspenseQuery({
		queryKey: [ECacheKeys.ItemsLayout],
		queryFn: () => getItemsLayout(params),
	});

	return query;
};
